// extracted by mini-css-extract-plugin
export default {"main_container":"InCompletePaymentNew_main_container__h4juj","incomplete_payment":"InCompletePaymentNew_incomplete_payment__Ffg8b","button":"InCompletePaymentNew_button__-JQ1D"};